export default __webpack_public_path__ + "static/media/12D.a418639b.jpg";